import { Injectable } from '@angular/core';
import { FeatureToggleService } from '../feature-toggle/feature-toggle.service';
import { ConfigService } from '../config/config.service';
import { DeviceService } from '../device/device.service';
import { DeviceSettingsDefaultValueService } from '../feature-toggle/device-settings-default-value/device-settings-default-value.service';

@Injectable({
	providedIn: 'root',
})
export class InitializerService {
	constructor(
		private featureToggleService: FeatureToggleService,
		private configService: ConfigService,
		private deviceService: DeviceService,
		private deviceSettingsDefaultValueService: DeviceSettingsDefaultValueService
	) {}

	initialize(): Promise<any> {
		sessionStorage.clear();

		const timeout = (ms) => {
			return new Promise((resolve, reject) => {
				setTimeout(function () {
					resolve('Success');
				}, ms);
			});
		};

		return Promise.race([
			Promise.all([this.initializeFeatureToggle(), this.deviceService.getMMDInfo()]),
			timeout(3000),
		]).finally(() => {
			this.configService.initGetMenuItems();
		});
	}

	async initializeFeatureToggle(): Promise<any> {
		await this.featureToggleService.initialize();
		this.deviceSettingsDefaultValueService.initialize(
			this.featureToggleService.deviceSettingsPolicyTable
		);
	}
}
